import { render } from "./BasicDatatable.vue?vue&type=template&id=6cba50d4&scoped=true"
import script from "./BasicDatatable.vue?vue&type=script&lang=js"
export * from "./BasicDatatable.vue?vue&type=script&lang=js"

import "./BasicDatatable.vue?vue&type=style&index=0&id=6cba50d4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cba50d4"]])

export default __exports__